<div class="c-dialog__icon" [ngClass]="config.theme" *ngIf="config.icon">
    <pay-icon name="{{config.icon}}" class="mod-xlg"></pay-icon>
</div>
<pay-dialog-title>{{ config.title | translate }}</pay-dialog-title>
<pay-dialog-body [formGroup]="verificationForm" [payFormSubmitted]="submitted">
    <div class="mb-5"> {{config.content | translate: config.contentParams}}</div>
    <div class="ml-6 mr-6">
        <input type="text"
               class="c-form-control"
               formControlName="verificationCode"
               (keydown.enter)="verify()">
        <pay-form-messages [form]="verificationForm" name="verificationCode" [submitted]="submitted">
            <pay-form-message name="required">{{'HelpHint.Required' | translate: { name: helpHintName } }}
            </pay-form-message>
            <pay-form-message name="minlength">{{'HelpHint.MinLength' | translate: { name: helpHintName,  length: minLength} }}
            </pay-form-message>
            <pay-form-message name="maxlength">{{'HelpHint.MaxLength' | translate: { name: helpHintName,  length: maxLength}  }}
            </pay-form-message>
        </pay-form-messages>
    </div>
</pay-dialog-body>
<pay-dialog-actions>
    <pay-button-group class="c-btn-group--gap-4 justify-content-center ">
        <button payButton type="button"
                class="c-btn--base c-btn--wlg c-btn--lg"
                payDialogClose
                [disabled]="isClosing">
            {{'Common.Cancel'|translate}}
        </button>
        <button payButton type="button"
                class="c-btn--primary c-btn--wlg c-btn--lg"
                (click)="verify()"
                [disabled]="isClosing">
            {{'Common.Verify'|translate}}
        </button>
    </pay-button-group>
</pay-dialog-actions>
